import { Title, Stack, Image } from '@mantine/core';
import { BaseLayout, Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import WallForming from 'app/assets/wallforming.jpeg';
import { PlanStartRoute, WallFormingBaseRoute } from 'app/modules/routePaths';
import { useIsStandaloneMode } from 'shared/hooks/useIsStandaloneMode';

export const Home = () => {
    const { t } = useTranslation();
    const isStandaloneMode = useIsStandaloneMode();

    return (
        <BaseLayout
            className="bg-background-gray-ultra-ultra-light"
            environment={import.meta.env.VITE_ENVIRONMENT}
            innerClassName="h-full p-6"
            versionNumber={APP_VERSION}
            withCookieBanner={false}
        >
            <Stack align="center">
                <Title my="xl" order={4}>
                    {t('home')}
                </Title>
                <div className="flex gap-xl flex-wrap justify-center">
                    {isStandaloneMode && (
                        <Link
                            className="card border-border-ultra-light hover:card-clickable flex w-72 flex-col"
                            data-testid="home-start-from-plans"
                            to={`/${PlanStartRoute}`}
                        >
                            <div className="flex h-40 items-center justify-center rounded-sm bg-background-gray-ultra-light">
                                <Icon icon="upload_file" size="xl" style={{ fontSize: 64 }} />
                            </div>
                            <Title className="mt-4" order={4} ta="center">
                                {t('titlePlanStart')}
                            </Title>
                            <div className="mt-1 text-center text-sm text-text-light">{t('infoHomePlanStart')}</div>
                        </Link>
                    )}
                    <Link
                        className="card border-border-ultra-light hover:card-clickable flex flex-row"
                        to={`/${WallFormingBaseRoute}`}
                    >
                        <Stack>
                            <Image src={WallForming} />
                            <Title className="mt-4" order={4} ta="center">
                                {t('titleWallForming')}
                            </Title>
                        </Stack>
                    </Link>
                </div>
            </Stack>
        </BaseLayout>
    );
};
